import { getUrlParameter, getCookieByName } from 'common';
import cryptojs from 'crypto-js';
import sha256 from 'crypto-js/sha256';

export const executeGoogPixels = (props) => {
  const { location, VisitIndex } = props;
  console.log(props);
  // console.log(`VisitIndex: ${VisitIndex}`);

  if (VisitIndex >= 10) {
    return;
  }

  console.log(location);
  console.log('Run Google Pixel');
  switch (location) {
    case 'email_submit':
      // google conversion
      console.log(typeof gtag_report_conversion === 'function');
      if (typeof gtag_report_conversion !== 'undefined') {
        if ([5, 6].indexOf(window.sooper_panel.props.funnel_id) !== -1) {
          // gtag_report_conversion();
          gtag('event', 'conversion', {
            send_to: 'AW-16867086107/zILfCJz80pwaEJue7eo-',
          });
          console.log(
            `BlissfulDaily - Google Pixel Triggered for ID ${window.sooper_panel.props.funnel_id}`,
          );
        } else {
          gtag_report_conversion();
          console.log(
            `EverydayChance - Google Pixel Triggered for ID ${window.sooper_panel.props.funnel_id}`,
          );
        }
      }
      break;
    case 'form_submit':
      // if (typeof gtag != 'undefined') {
      //   gtag('event', 'offer_detail_seen');

      //   // 	Email Submit
      //   gtag('event', 'conversion', {
      //     send_to: 'AW-432472621/hcdJCOO6ivUBEK2EnM4B',
      //   });

      //   // EW Email Submit
      //   gtag('event', 'conversion', {
      //     send_to: 'AW-432472621/LSc6CIfc0fgCEK2EnM4B',
      //   });
      // }

      // if (typeof ga != 'undefined') {
      //   // EW Email Submit (All Web Site Data)
      //   ga('send', 'event', 'button', 'click', 'confirm entry');
      // }
      break;
  }
};

export const registerPixels = (pixels) => {
  if (!Array.isArray(pixels)) {
    return;
  }

  const container = document.createElement('div');
  container.style.display = 'none';
  pixels.forEach((uri) => {
    let frame = document.createElement('iframe');
    frame.setAttribute('src', uri);
    frame.setAttribute('height', 1);
    frame.setAttribute('width', 1);
    container.appendChild(frame);
  });
  document.body.prepend(container);
};

const goog_snippet_vars = () => {
  var w = window;
  w.google_conversion_id = 432472621;
  w.google_conversion_label = 'LSc6CIfc0fgCEK2EnM4B';
  w.google_remarketing_only = !1;
};

export const goog_report_conversion = (url) => {
  goog_snippet_vars();
  window.google_conversion_format = '3';
  let opt = new Object();

  opt.onload_callback = () => {
    if (typeof url != 'undefined') {
      window.location = url;
    }
  };

  let conv_handler = window.google_trackConversion;

  if (typeof conv_handler == 'function') {
    conv_handler(opt);
  }
};

export const onLoadPixels = () => {
  let source = getUrlParameter('utm_source').toLowerCase(),
    term = getUrlParameter('utm_term'),
    sources = ['lifestreetdspsweeps1781', 'lifestreetdspandroidsweeps1792'];

  if (sources.indexOf(source) === -1) {
    return;
  }

  if (window.hasOwnProperty('sooper_panel') === false) {
    return;
  }

  var payload = Object.assign(
    Object.fromEntries(new URLSearchParams(window.location.search)),
    {
      visit_id: sooperCookie.visitID,
      funnel_id: parseInt(getUrlParameter('override')),
      uri: window.location.href,
    },
  );

  delete payload.override;

  if (payload.hasOwnProperty('utm_medium')) {
    payload.utm_medium = parseInt(payload.utm_medium);
  }

  if (payload.hasOwnProperty('r')) {
    payload.r = parseInt(payload.r);
  }
};

const eventTikTok = (props) => {
  var source = getUrlParameter('utm_source') || '';

  if (typeof ttq !== 'object' || props.funnel_id !== 33) {
    return;
  }

  if (!props.EmailAddress && !props.user_id) {
    return;
  }

  if (source.toLowerCase() !== 'tiktokprelandersweeps2192') {
    return;
  }

  ttq.identify({
    email: cryptojs.enc.Hex.stringify(sha256(props.EmailAddress)),
    external_id: cryptojs.enc.Hex.stringify(sha256(props.user_id)),
  });

  ttq.track('SubmitForm', {});
};

const eventSnapChat = (props) => {
  if (typeof snaptr !== 'function' || !props.EmailAddress) {
    return;
  }

  let payload = {
    sign_up_method: 'EmailSubmit',
    click_id: getUrlParameter('ScTestModeId') ?? getUrlParameter('ScCid'),
    uuid_c1: getCookieByName('_scid'),
    //   getUrlParameter('ScTestModeId') ??
    //   getUrlParameter('ScCid') ??
    //   getCookieByName('_scid'),
    user_email: props.EmailAddress,
    user_hashed_email: cryptojs.enc.Hex.stringify(sha256(props.EmailAddress)),
  };

  console.log(payload);

  // if (props?.PhoneNumber) [
  //   payload.user_phone_number
  // ]

  snaptr('track', 'SIGN_UP', payload);
};

const eventAudigent = () => {
  var elem = document.createElement('script');
  elem.async = 1;
  elem.src = `https://a.ad.gt/api/v1/u/matches/620?url=${encodeURIComponent(
    window.location.href,
  )}&ref=${encodeURIComponent(document.referrer)}`;
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.appendChild(elem);
};

const eventCriteo = (props) => {
  if (typeof window.criteo_q !== 'object' || props.id === '') {
    return;
  }

  const { id, VisitIndex, EmailAddress } = props,
    source = getUrlParameter('utm_source') || '',
    criteo_id = props.criteo_id || 36674,
    criteo_bucket_limit = props.criteo_bucket_limit || 2;

  if ([33, 34, 37].includes(props.funnel_id)) {
    window.criteo_q.push(
      {
        event: 'setAccount',
        account: criteo_id,
      },
      {
        event: 'setSiteType',
        type: /iPad/.test(navigator.userAgent)
          ? 't'
          : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
              navigator.userAgent,
            )
          ? 'm'
          : 'd',
      },
      {
        event: 'setEmail',
        email: [EmailAddress],
        hash_method: 'none',
      },
      {
        event: 'setZipcode',
        zipcode: '',
      },
      {
        event: 'trackTransaction',
        // deduplication: source.toLowerCase().indexOf('criteo') === -1 ? 0 : 1,
        tms: 'custom-guide',
        id: props.id,
        item: [
          {
            id: '1',
            price: '0',
            quantity: '1',
          },
        ],
      },
    );

    return;
  }

  window.criteo_q.push(
    {
      event: 'setAccount',
      account: criteo_id,
    },
    {
      event: 'setSiteType',
      type: /iPad/.test(navigator.userAgent)
        ? 't'
        : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
            navigator.userAgent,
          )
        ? 'm'
        : 'd',
    },
    {
      event: 'setEmail',
      email: [EmailAddress],
    },
    {
      event: 'trackTransaction',
      deduplication: source.toLowerCase().indexOf('criteo') === -1 ? 0 : 1,
      id: id,
      item: [
        {
          id: '1',
          price: 0,
          quantity: 1,
        },
      ],
    },
  );

  setTimeout(() => {
    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push(
      {
        event: 'setAccount',
        account: criteo_id,
      },
      {
        event: 'viewHome',
      },
      {
        event: 'setData',
        ui_bucket:
          VisitIndex >= parseInt(criteo_bucket_limit)
            ? 'RepeatConverters'
            : 'Converters',
      },
    );
  }, 500);
};

const eventLiveIntent = (props) => {
  if (typeof window.liQ !== 'object') {
    return;
  }

  window.liQ = window.liQ || [];
  window.liQ.push({
    event: 'conversion',
    name: 'email_signup',
    email: props.EmailAddress,
  });
};

export const eventAppNexusPixel = (id) => {
  const order_id = id || '',
    pixel = document.createElement('img');

  pixel.setAttribute(
    'src',
    `https://secure.adnxs.com/px?id=1693448&t=2&order_id=${order_id}&value=$0.60`,
  );
  pixel.height = pixel.width = 1;

  if (!document.getElementById('pixels')) {
    return document.body.prepend(pixel);
  }

  document.getElementById('pixels').appendChild(pixel);
};

const eventLifeStreetDSP = () => {
  let source = getUrlParameter('utm_source').toLowerCase(),
    term = getUrlParameter('utm_term'),
    pixel = document.createElement('img');

  pixel.setAttribute(
    'src',
    'https://pix.lfstmedia.com/_tracker/81?__noscript=true&__sid=' + term,
  );
  pixel.setAttribute('id', source);
  pixel.style.display = 'none';

  if (!document.getElementById('pixels')) {
    return document.body.prepend(pixel);
  }

  document.getElementById('pixels').appendChild(pixel);
};

export const execute3rdPartyPixels = (props) => {
  if (!props.VisitIndex) {
    return;
  }

  props.VisitIndex = parseInt(props.VisitIndex);
  // eventCriteo(props);
  // eventLiveIntent(props);
  // eventAudigent();
  // eventTikTok(props);
  // eventSnapChat(props);
  // eventAppNexusPixel('');
  // eventLifeStreetDSP();
};

export const execBigoS2SWebEvent = (props) => {
  const r = new XMLHttpRequest();
  r.open('POST', '/api/sooper/pixel/bigo');
  r.setRequestHeader('Content-Type', 'application/json');
  r.onload = function () {
    console.log(r.status);
    console.log(r.response);
  };
  r.send(JSON.stringify(props));
};

export const execNewsbreakPostback = (props) => {
  const r = new XMLHttpRequest();
  r.open('POST', '/api/sooper/pixel/newsbreak');
  r.setRequestHeader('Content-Type', 'application/json');
  r.onload = function () {
    console.log(r.status);
    console.log(r.response);
  };
  r.send(JSON.stringify(props));
};
